import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getCmsList = (current, size, params) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/cmsList',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/submit',
    method: 'post',
    data: row
  })
}

export const cmsSubmit = (row) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/cmsSubmit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/sino-attractMeet/attractMeet/submit',
    method: 'post',
    data: row
  })
}

